
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './sobrenosotrosekrzx.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Psobrenosotrosekrzx = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690f9e318e5aed52dc850104" >

      <div id="ii5j" className="">
      
      <div id="i2wm" className="">
      
      <div id="i3to" className="">
      
      <div id="i4zac" className="">
      
      <div id="i1br3w" className="">
      
      <div id="iq3oci" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iyoins"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="iqxn7c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iup45h"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iyzeef"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="if3occ"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="i3pbhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="irgcil"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iro1nx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ibua3s" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="istkj" className="">
      
      <div id="ivpj2" className="">
      
        <LoftyDropdownComponent
          id="ioqu92"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="it8zvy" className="gjs-dropdown-menu-trigger link-navegacion ">
<>Ecosistema chamba
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="i2eqkj" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navegacion "
          id="i0llh"
          href="/index"
        >
          
    <div id="ij1vq" className="">
    <>Chamba Index</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i4g3fb"
          href="/chambanomics"
        >
          
    <div id="i6jxka" className="">
    <>Chambanomics</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i68lj"
          href="/chambometro"
        >
          
    <div id="inisp" className="">
    <>Chambómetro Electoral</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="iog9i6"
          href="/talks"
        >
          
    <div id="iogkoj" className="">
    <>Chamba talks</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ievl0d"
          href="/chambeador"
        >
          
    <div id="i40bdb" className="">
    <>Chambeador del año</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className="link-navegacion "
          id="ilnkvn"
          href="/fundacion"
        >
          
    <div id="iv451u" className="">
    <>Fundación</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="iaa1w" className="">
      
        <a
          target=""
          className=""
          id="itud73"
          href="/"
        >
          
      <img
        className=""
        id="ilkbh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4z2t" className="">
      
        <a
          target=""
          className="link-navegacion "
          id="ixf4dl"
          href="/sobrenosotros"
        >
          
    <div id="ijolgi" className="">
    <>Sobre Nosotros</>
    </div>
    
        </a>
        
        <a
          target="_blank"
          className="link-navegacion "
          id="iybqde"
          href="https://cne.chamba.hn/"
        >
          
    <div id="i3x27s" className="">
    <>Centro electoral</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i23lgf" className="">
      
      <img
        className=""
        id="iaxk7b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/talks"
        type=""
      >
        <>Chamba Talks</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/fundacion"
        type=""
      >
        <>Fundación</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambometro"
        type=""
      >
        <>Chambómetro</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambeador"
        type=""
      >
        <>Chambeador del año</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/agregarcv"
        type=""
      >
        <>Postular</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="isa7id"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="i9x2g" className="">
      
      <div className="" id="im8zk">
        <>Sobre Nosotros</>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i9o19h" className="">
      
      <img
        className=""
        id="ixqn8u"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxjnni.png"
        alt="undefined"
      />
      
      <div
        id="ioo64y"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div
        id="ib1cd8"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i3b317" className="">
      
      <div id="iivtfr" className="">
      
      <div className="" id="icqi9o">
        <>Misión</>
      </div>
      
      <div className="" id="ivlcnl">
        <>En Chamba trabajamos para construir una economía fuerte, donde todos los hondureños podamos crecer juntos.</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijluj">
        <>Visión</>
      </div>
      
      <div className="" id="iahjjf">
        <>Una Honduras con chamba de calidad.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="ix7bdo" className="">
      
      <img
        className=""
        id="i47mr4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhsq1wdc.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="i11ath"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxlys4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6yyhl" className="">
      
      <div
        id="ih6eoa"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="" id="iw3bdm">
        <>Chamba no es solo una plataforma</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iydme9">
        <>Es un ecosistema que conecta el talento, la oportunidad y la innovación</>
      <br className="" id="" />
      <>para transformar el futuro de Honduras</>
      </div>
      
      <div id="isg2x7" className="">
      
        <a
          target=""
          className="boton-principal "
          id="idam18"
          href="/contacto"
        >
          
      <span className="" id="i4irhj">
        <>Únete ahora</>
      </span>
      
        </a>
        <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="izwmsw" className="">
      
      <div id="izhw0e" className="">
      
      <div className="" id="ihrikl">
        <>Nuestros Valores</>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ivx1g6"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div
        id="iab6i6"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ii51sw" className="">
      
      <img
        className="img-tarjeta-programa "
        id="ie1dtl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqpmk4a.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iebgsd" className="">
      
      <div className="titulo-tarjeta-programa " id="i5li5v">
        <>Comunidad</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="im9z3e">
        <>Creemos en el poder de las conexiones humanas y la colaboración</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ij7uuj"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ic7d9k" className="">
      
      <img
        className="img-tarjeta-programa "
        id="im3uia"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqpnbip.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="irlggp" className="">
      
      <div className="titulo-tarjeta-programa " id="imj1an">
        <>Impacto</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="ibryos">
        <>Medimos nuestro éxito por el cambio positivo que generamos</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="if2s1t"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i029cf" className="">
      
      <img
        className="img-tarjeta-programa "
        id="i8pyu4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqpnyro.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i8erjg" className="">
      
      <div className="titulo-tarjeta-programa " id="ix3l9e">
        <>Inclusión</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="ihzmab">
        <>Trabajamos para que nadie se quede atrás en el desarrollo</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="im78" className="">
      
      <div id="imr134" className="">
      
      <div id="i3kmzi" className="">
      
      <img
        className=""
        id="ijd9oi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div className="" id="iurhsm">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      </div>
      <>
        </>
      </div>
      
      <div id="igpnrp" className="">
      
      <div className="" id="iwmzhr">
        <>Siguenos</>
      </div>
      
      <div id="ii0mf" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="igd3x"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivqnc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="i5j0k"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="ibnrn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="ir76u"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="imcck"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="izuti"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iyz7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="id4zm3">
        <>© 2025 CHAMBA. Todos los derechos reservados.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Psobrenosotrosekrzx);
  